import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import moment from "moment"
import VueMomentJS from "vue-momentjs"
import axios from 'axios';
import {AUTH_REFRESH} from './store/actions/auth'

Vue.config.productionTip = false;

Vue.use(VueMomentJS, moment)

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API

Vue.prototype.$http = axios

// Add request interceptors
axios.interceptors.request.use((config) => {
  console.log('Request:', config);
  return config;
}, (error) => {
  console.log(error);
  return Promise.reject(error);
});

// Add response interceptors
axios.interceptors.response.use((response) => {
  console.log('Response:', response);
  return response;
}, (error) => {
  if (error.response.status === 401 && error.response.data.code === 'token_not_valid') {
    console.log('Getting Refresh Token')
    return store.dispatch(AUTH_REFRESH, localStorage.getItem('user-refresh'))
    .then((data) => {
      error.config.headers.Authorization = `Bearer ${data.access}`
      return axios.request(error.config);
    }).catch((error) => {
      delete axios.defaults.headers.common['Authorization']
      location.reload()
      return Promise.reject(error);
    })
  } else {
    return Promise.reject(error);
  }
});


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
